//------------------------------------------------------ funciones
import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";

const TABLA = "proveedores";

// Realtime para listado
export const subscribeProveedores = (callback) =>
  subscribeTable(TABLA, callback);

export const createProveedor = ({ id, ...data }) => createRow(TABLA, id, data);

export const updateProveedor = (id, data) => updateRow(TABLA, id, data);

export const deleteProveedor = (id) => deleteRow(TABLA, id);
